import { useMemo } from 'react';
import { createResourceAtom } from 'lib/atoms';
import { ScenariosResponse } from 'types/api-responses';

const useScenariosAtom = (href: string | undefined) =>
  useMemo(() => createResourceAtom<ScenariosResponse[]>(href), [href]);

export { useScenariosAtom };
